"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _actions = require("../redux/actions");
var _constants = require("../utils/constants");
var _selectors = require("../redux/selectors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useHandleFlushDuration = _ref => {
  let {
    thingPDIDDevice
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const device = (0, _reactRedux.useSelector)(_selectors.selectDevicesById)[thingPDIDDevice] || null;
  const handleFlushDuration = (0, _react.useCallback)(duration => {
    try {
      if (!device) throw Error('No device');
      dispatch((0, _actions.setFlushingDuration)({
        forRedux: {
          thingPDIDDevice
        },
        name: _constants.commandsByType[_constants.commandsTypes.FLEX_DURATION],
        devices: [{
          edgeNodePDID: device.thingPDID,
          devicePDID: device.thingPDIDDevice,
          modbus: device.thingDeviceAddress,
          equipmentType: device.equipmentType
        }],
        valueType: 'int',
        value: duration,
        type: 1
      }));
    } catch (error) {
      console.error(error);
    }
  }, [dispatch, thingPDIDDevice, device]);
  return {
    handleFlushDuration
  };
};
var _default = exports.default = useHandleFlushDuration;